/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './animation016.less';
import { usePlayFlag } from './../../components/topicScroll';
import Attention from '../../../../../assets/a016-attention-market.svg';

interface IAnimation016Item {
  img: string;
  title: string;
  content: string;
  list: [];
}

const bgTemplate = ['#F26927', '#D23D21', '#FAAD14'];

const getBG = (feed: number) => bgTemplate[feed % bgTemplate.length];

interface IAnimation016Props {
  title: string;
  items: IAnimation016Item[];
  style?: React.CSSProperties;
  className?: string | null;
  onCompleted?: () => void;
}

const Animation016: React.FunctionComponent<IAnimation016Props> = ({
  title,
  items,
  style,
  className,
  onCompleted,
}) => {
  const crrRef = React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const [play, setPlay] = React.useState(1);
  const startPlay = (next = 1) => {
    setPlay(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 1200);
    } else {
      console.log('Animation016 onCompleted');
      onCompleted && onCompleted();
    }
  };

  React.useEffect(() => {
    if (playFlag) {
      startPlay();
    }
  }, [playFlag]);
  return (
    <div
      ref={crrRef}
      className={`animation016 component ${className}`}
      style={style}
    >
      <div className="animation016-attention">
        <img src={Attention} alt="" />
        <div
          className="animation016-attention-text"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div className="animation016-content">
        {items.map((itm: IAnimation016Item, idx: number) => (
          <div
            key={idx}
            className={`animation016-item  animation ${
              play >= idx + 1 ? 'fade-in' : ''
            }`}
            style={{ width: `${(1 / items.length) * 100}%` }}
          >
            <div className="animation016-image">
              <img
                src={require(`../../../../../assets/${itm.img}`).default}
                alt=""
              />
            </div>
            <div
              className="animation016-header"
              style={{
                backgroundColor: getBG(idx),
              }}
              dangerouslySetInnerHTML={{ __html: itm.title }}
            />
            <div className="animation016-content">{itm.content}</div>
            <div className="animation016-list">
              <ul>
                {itm.list.map((itms: string, idxs: number) => (
                  <li key={idxs}>{itms}</li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

Animation016.defaultProps = {
  style: {},
};

export default Animation016;
